/**
 * Ajax Form Submit Event Delegation
 *
 * All forms with an [data-request-validation] attribute will run through this.
 *
 * Options can be added as data-attributes, e.g. <form data-request-validation data-field-error-messages="true" data-form-message="false">
 *
 *

data-form-message - Prepend form with error/success message - default true
data-field-error-classes - Adds is-erroneous class to each form field which didn't pass validation - default true
data-field-error-messages - Adds specific error message after each form field - default false
 */

$(function(){
	$('input[name="_resolution"]').val(window.screen.width + 'x' + window.screen.height);
});

$(document).on('ajax:request-error', '[data-request-validation]', function(event) {
	console.log('Event: ajax:request-error', event.detail);
	const { context, message: frameworkMessage, xhr } = event.detail;

	var $form = $(this),
		fixedMessage = ($form.attr('data-form-fixed-message') || true),
		prependMessage = ($form.attr('data-form-message') || false),
		appendMessage = ($form.attr('data-form-message-bottom') || false),
		addErrorClasses = ($form.attr('data-field-error-classes') || true),
		addErrorMessagesToFields = ($form.attr('data-field-error-messages') || true),
		defaultErrorMessage = ($form.attr('data-default-error-message') || true);

	// Get error message
	var errorMessage = event.detail.message.$env.message || frameworkMessage || 'An error occurred while submitting the form. Please try again.';

	if(defaultErrorMessage.length > 0){
		errorMessage = defaultErrorMessage;
	}

	var message = '<div class="form-response form-error-message alert alert-warning">' + errorMessage + '</div>';

	// Remove old ones
	$('.form-fixed-response').remove();
	$form.find('.form-error-message').remove();

	// Add fixed error message to page
	if (fixedMessage === true)
	{
		$('body').append('<div class="form-fixed-response"><div class="container">' + message + '</div></div>');
		$('.form-fixed-response').fadeIn(200);
	}

	if (prependMessage === true)
	{
		// Prepend error message
		$form.prepend(message);
	}

	if (appendMessage === true)
	{
		// Append error message
		$form.append(message);
	}

	if (addErrorClasses === true || addErrorMessagesToFields === true)
	{
		var errorFields = event.detail.message.$env.invalid || null;

		// Remove fields with error class
		$form.find(':input.is-erroneous').removeClass('is-erroneous');

		// Remove field error message
		$form.find('.input-error-message').remove();

		if (errorFields)
		{
			$.each(errorFields, function(field, message) {

				// fixes names and messages of fields in an array
				if(field.indexOf('.') !== -1) {
					var fieldParts = field.split('.');
					field = '';

					$.each(fieldParts, function(key, fieldPart) {
						if (key == 0) {
							field += fieldPart;
						} else {
							field += '[' + fieldPart + ']';
						}
					});

					message[0] = message[0].replace('.', ' ');
				}

				var $field = $form.find(':input[name="' + field + '"]');

				if (addErrorClasses === true) $field.addClass('is-erroneous');
				if (addErrorMessagesToFields === true) {
					if ($field.attr('type') !== 'hidden' && $field.attr('name') !== '_cpt_hpot') {
						if ($field.attr('type') === 'checkbox') {
							$field.parent('.form-check').append('<div class="input-error-message">' + message[0] + '</div>');
						} else if ($field.attr('type') === 'radio') {
							$field.parents('.form-group').append('<div class="input-error-message">' + message[0] + '</div>');
						} else if ($field.is('select')) {
							$field.parents('.form-group').append('<div class="input-error-message">' + message[0] + '</div>');
						} else if ($field.attr('type') != 'hidden') {
							$field.each(function() {
								if ($(this).attr('type') != 'hidden') {
									// Change 'password confirmation must be between 6 and 255 characters' message
									if(message[0].toLowerCase().indexOf('the password confirmation must be between') >= 0){
										$(this).after('<div class="input-error-message">Password must be at least 8 characters including one lowercase, one uppercase and one number</div>');
									} else {
										$(this).after('<div class="input-error-message">' + message[0] + '</div>');
									}
								}
							});
						}
					}
				}

				if($field.length == 0){
					var $label = $form.find(':input[name="' + field + '[]"]').parents('.form-group').first('label');
					if (addErrorMessagesToFields === true) $label.after('<div class="input-error-message">' + message[0] + '</div>');
				}

			});
		}
	}

	// remove fixed error message after 5 secs
	setTimeout(function() {
		$('.form-fixed-response').fadeOut(300, function(){
			$(this).remove();
		});
	}, 5000);

	// This prevents the alert from showing.
	return false;
});

$(document).on('ajax:request-success', '[data-request-validation]', function(event) {
	var $form = $(this),
		fixedMessage = ($form.attr('data-form-fixed-message') || true),
		prependMessage = ($form.attr('data-form-message') || false),
		appendMessage = ($form.attr('data-form-message-bottom') || false),
		clearForm = ($form.attr('data-clear-on-success') || true),
		successMessage = ($form.attr('data-success-message') || "Thanks, your message has been submitted successfully"),
		messageDelay = ($form.attr('data-delay-message') || 5000),
		showSuccessMessage = ($form.attr('data-form-show-success-message') || true);

	// Remove fixed form message
	$('.form-fixed-response').fadeOut(300, function(){
		$(this).remove();
	});

	// Remove prepended error message
	$form.find('.form-error-message').remove();

	// Remove fields with error class
	$form.find(':input.is-erroneous').removeClass('is-erroneous');

	// Remove field error message
	$form.find('.input-error-message').remove();

	var message = '<div class="form-response form-error-message alert alert-success">' + successMessage + '</div>';

	// Add fixed success message to page
	if (fixedMessage === true && showSuccessMessage === true)
	{
		$('body').append('<div class="form-fixed-response"><div class="container">' + message + '</div></div>');
		$('.form-fixed-response').fadeIn(200);
	}

	// Prepend success message
	if (prependMessage === true)
	{
		$form.prepend(message);
	}

	// Append success message
	if (appendMessage === true)
	{
		$form.append(message);
	}

	if(clearForm === true)
	{
		$form.find(':input')
			.removeAttr('checked').removeAttr('selected')
			.not('[type=checkbox], [type=radio], :button, :submit, :reset, :hidden').val('');

		$form.find('input[type="file"]').trigger('change');
	}

	// remove success labels after 5 secs
	setTimeout(function() {
		$form.find('.form-error-message').slideUp(400, function(){
			$(this).remove();
		});

		$('.form-fixed-response').fadeOut(300, function(){
			$(this).remove();
		});
	}, messageDelay);

});


$(document).on('ajax:request-success', '[data-ga-event]', function(event) {
	var $this = $(this);


	var eventAction = ($this.data('ga-action') ? $this.data('ga-action') : 'submit');

	if (typeof gtag === 'function') {
		gtag('event', eventAction, {
			'event_category': $this.data('ga-category'),
			'event_label': $this.data('ga-label'),
		});
	} else if (typeof ga === 'function') {
		ga('send', {
			hitType: 'event',
			eventCategory: $this.data('ga-category'),
			eventAction: eventAction,
			eventLabel: $this.data('ga-label')
		});
	}

});

// Custom success script (october one can be tempremental)
$(document).on('ajax:request-success', '[data-success-script]', function(event) {
	var $form = $(this),
		messageDelay = ($form.attr('data-delay-message') || 0);

	setTimeout(function(){
		eval($form.data('success-script'));
	}, messageDelay);
});

// disable submit button when making request
$(document).on('submit', '[data-request]', function(){
	var $form = $(this),
		$submit = $form.find('[type="submit"]');

	$submit.prop('disabled', true);
});

// re-enable submit button after request is done
$(document).on('ajax:request-complete', '[data-request]', function(){
	var $form = $(this),
		$submit = $form.find('[type="submit"]');

	$submit.prop('disabled', false);
});

// update from values to window.site
$(document).on('submit', '[data-update-form-values]', function() {

	let values = [];

	$('form.js-warn-changes :input').each(function() {
		if ($(this).attr('type') == 'checkbox') {
			if ($(this).prop('checked')) {
				values.push($(this).attr('name') + $(this).val());
			}
		} else {
			values.push($(this).val());
		}
	});

	window.site.formVals = values;
});

$(document).on('ajax:request-success', '[data-request-update-url]', function(event) {
	var $form = $(this),
		data = $form.serializeArray(),
		path = window.location.pathname,
		queryString = '';

	// remove october fields from string
	$.each(data, function(key, item){
		if(item.name.indexOf('_session_key') == 0 || item.name.indexOf('_token') == 0) {
			delete data[key];
		} else if (item.name == 'page' && item.value == 1) {
			delete data[key];
		} else if (item.name == 'sort_by' && item.value == 4) {
			delete data[key];
		} else if (item.name == 'records' && item.value == 12) {
			delete data[key];
		} else if (item.name == 'recordsPerPage' && item.value == 12) {
			delete data[key];
		} else if (item.value != '' || item.value != 0) {
			queryString += '&' + item.name + '=' + item.value;
		}
	});

	queryString = queryString.substring(1);
	queryString = '?' + queryString;

	if (typeof (history.pushState) != "undefined") {
		history.pushState(null, null, path + queryString);
	}

});